define('responsive-gameday/controllers/WrapupPlaysViewController',['require','exports','module','./PlayByPlayViewController','message-service/message-service'],function(require,exports,module){
    // Add private variables here
    var PlayByPlayViewController = require( "./PlayByPlayViewController" ),
        MessageService = require("message-service/message-service");

    var renderers = null,
        Superclass;
    
    // Constructor
    function WrapupPlaysController(type) {
        // Call super constructor
        Superclass.constructor.call(this);
        this.referenceName = "WrapupPlays";

        MessageService.publish("registerViewComponent", this);
    }

    // Prototype Inheritence
    PlayByPlayViewController.spawn(WrapupPlaysController).define({
        loadView : function(){
            Superclass.loadView.call(this);
            this.setClassName("WrapupPlaysController wide-view");            
            this.canScroll=false;
            this.showLinescore = false;
            this.scores.canScroll = false;
            this.innings.canScroll = false;

        }
    });

    Superclass = WrapupPlaysController.superclass;
    return WrapupPlaysController;
});
